<template >
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'ElektraWeb Check User'"
        :key="isSelectCount"
        :buttons="[
          {
            title: isSelectCount > 0 ? `Check User (${isSelectCount})` : 'Check User',
            icon: 'fa fa-clipboard-check',
            emit: 'checkUsers',
            class: 'btn-primary mx-3' +(
              (data==null || data.filter(x=>x.isSelected).length==0) ? ' disabled' : ''
            ),
          },
          {
            title: 'Reload',
            icon: 'fa fa-sync',
            emit: 'reload',
          },
        ]"
        @reload="getUsers(model.SoftwareId)"
        @checkUsers="checkUsers"
      ></cardHead>

      <!-- <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels row p-20 p-b-10"
        ref="form"
      >
      <div class="row ">
        <div class="col-3">
          <searchSelect
            :title="'SoftwareId'"
            v-model="model.SoftwareId"
            :errors="errors"
            :data="
              $orderByArray(
                softwares.filter(x => this.validSoftwareIds.includes(x.Id)).map((x) => {
                  return { value: x.Id, text: x.Name };
                }),
                'Id',
                false,
                false
              )
            "
          ></searchSelect>
        </div>
      </div>

      </Form> -->

      <div class="tables rel">
        <div
          class="myCheckBox abs"
          style="top: 47px; z-index: 5; left: 6px;"
          >
          <input
            type="checkbox"
            class="filled-in"
            v-model="selectAll"
            id="chckMassCheckUser"
          /><label for="chckMassCheckUser"></label>
        </div>
        <dataTable
          :name="'CheckUser'"
          ref="agGrid"
          :columnDefs="columnDefs"
          :data="data"
          @cellClicked="clickedCell"
           :rowClassRules="{
             select: (params) => {
               return params?.data?.isSelected == true;
           },
            danger: (params) => {
              return params?.data?.ControlRequired == true;
          },
        }"
        ></dataTable>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "checkUser",
  data() {
    return {
      columnDefs: [
        {
          headerName: "",
          width: 55,
          filter: false,
          field: "isSelected",
          sortable: false,
          cellClick: true,
        
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
          
        },
        {
          headerName: "Id",
          width: 80,
          filter: "agNumberColumnFilter",
          field: "Id",
          sortable: true,
          cellClick: true,
        },
         {
          headerName: "Ad Soyad",
          filter: "agTextColumnFilter",
          field: "UserName",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
        },
        
           {
          headerName: "P1-OtelKodu",
          filter: "agTextColumnFilter",
          field: "P1",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
        },
       
      
        {
          headerName: "Username",
          filter: "agTextColumnFilter",
          field: "P2",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "Password",
          filter: "agTextColumnFilter",
          field: "P3",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
        },
        {
          headerName: "TenantId",
          filter: "agTextColumnFilter",
          field: "P4",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
        },
            {
          headerName: "Otel Adı",
          filter: "agTextColumnFilter",
          field: "HotelName",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
        },
            {
          headerName: "Customer Adı",
          filter: "agTextColumnFilter",
          field: "CustomerName",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
        },
          {
          headerName: "Last Check Date",
          filter: "agTextColumnFilter",
          field: "LastCheckDate",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
            valueFormatter: function(params) {
            return params.value==null?"":moment(new Date(params.value)).format("DD-MM-YYYY HH:mm");
          },
        },
        {
          headerName: "Error Message",
          filter: "agTextColumnFilter",
          field: "ErrorMessage",
          flex: 1,
          minWidth: 160,
          sortable: true,
          cellClick: true,
           valueGetter: function(params) {
            return params.data?.ErrorMessage== "0" ?"Kullanıcı Bilgileri Hatalıdır": params.data?.ErrorMessage;
          },
        },
          {
          headerName: "Control Required",
          width: 175,
          filter: false,
          field: "ControlRequired",
          sortable: false,
          cellClick: true,
          floatingFilter: false,
          cellRenderer: this.$CheckCellRenderer,
        }
      ],
      model: {
        SoftwareId: 6,
      },
      data: null,
      softwares: [],
      selectAll: false,
      isSelectCount: 0,
      validSoftwareIds: [6],

    };
  },
  created() {
    this.getSoftwares();
    this.getUsers(this.model.SoftwareId);
  },
  watch: {
    selectAll() {
      if (!this.data) return;
      const pager = {
        min: this.$refs.agGrid.pager.currentPage * this.$refs.agGrid.pager.pageSize,
        max: (this.$refs.agGrid.pager.currentPage + 1) * this.$refs.agGrid.pager.pageSize,
      };
      const shouldSelect = this.selectAll;
      this.$refs.agGrid.gridApi.forEachNodeAfterFilterAndSort((rowNode, index) => {
        if (index >= pager.min && index < pager.max) {
          if (rowNode.data.isSelected !== shouldSelect) {
            this.$refs.agGrid.changeRow("Id", { ...rowNode.data, isSelected: shouldSelect });
          }
        }
      });
      this.isSelectCount = this.data.filter((x) => x.isSelected).length;
    },
  },
  methods: {
    getSoftwares() {
      this.$appAxiosAdmin.get(`Softwares`).then((response) => {
        this.softwares = response.data;
      });
    },
    clickedCell(param) {
      if (param.colDef.field == "isSelected") {
        this.$refs.agGrid.changeRow("Id", {
          ...param.data,
          isSelected: !param.data.isSelected,
        });
        this.isSelectCount = this.data.filter((x) => x.isSelected).length;
      }
    },
    checkUsers() {

      if(!this.data || this.data.filter(x=>x.isSelected).length==0) return;
      const ids = [];
      for (let i = 0; i < this.$refs.agGrid.gridApi.getDisplayedRowCount(); i++) {
        if (this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(i).data.isSelected) {
          ids.push(this.$refs.agGrid.gridApi.getDisplayedRowAtIndex(i).data.Id);
        }
      }
      if (ids.length === 0) return;
      this.$swal({
        icon: "question",
        title: "Uyarı!",
        text: `Emin misiniz ${ids.length} kullanıcıyı kontrol etmek istiyor musunuz?`,
        showCancelButton: true,
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .post(`UserHotels/CheckUserHotels`, ids)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Başarılı",
                text: "Kullanıcı kontrol işlemi tamamlandı.",
                timer: 3000,
                confirmButtonText: "Okey",
              }).then(() => {
                this.getUsers(this.model.SoftwareId);
                            this.selectAll = false;
                        this.isSelectCount = 0;
              });
            })
            .catch((err) => {
              this.$isError(err);

            }).finally(() => {
  

            });
        }
      });
    },
    getUsers(softwareId){
      this.data = null;
      this.selectAll = false;
      this.$appAxiosAdmin
        .get(`UserHotels`, { params: { SoftwareId: softwareId } })
        .then((response) => {
          response.data.forEach((x) => { x.isSelected = false; });
          this.data = response.data;
        })
        .catch((err) => {
          this.data = [];
          this.$isError(err);
        });
    }
  },
};
</script>
